module.exports = __webpack_public_path__ + "dimer/static/img/9.c386bed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/9.jpg
// module id = IFO5
// module chunks = 0